var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodeBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.61805 8.66176C0.49046 9.49816 1.0609 10.0787 1.75933 10.368C4.43698 11.4773 8.16322 11.4773 10.8408 10.368C11.5393 10.0787 12.1097 9.49816 11.9822 8.66176C11.9037 8.14774 11.516 7.7197 11.2287 7.30174C10.8525 6.74758 10.8151 6.14308 10.815 5.5C10.815 3.01472 8.79364 1 6.3001 1C3.80658 1 1.78518 3.01472 1.78518 5.5C1.78512 6.14308 1.74773 6.74758 1.37146 7.30174C1.0842 7.7197 0.696464 8.14774 0.61805 8.66176Z",
    stroke: "#3C3E4C",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90015 11.2002C4.17524 12.2353 5.14545 13.0002 6.30015 13.0002C7.45485 13.0002 8.42505 12.2353 8.70015 11.2002",
    stroke: "#3C3E4C",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBell);
export default __webpack_public_path__ + "static/media/code_bell.c94c1e2ac954d3d20f4144efc58f5f66.svg";
export { ForwardRef as ReactComponent };